import React from "react";
import { MapPin } from "lucide-react";

const HERO_IMG =
  "https://images.unsplash.com/photo-1692320152923-ce0ad6db27c5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxmb3Jlc3QlMjBsYWtlJTIwbmF0dXJlJTIwbGFuZHNjYXBlfGVufDB8fHx8MTc3OTIwNDk0MXww&ixlib=rb-4.1.0&q=85";

export const Hero = () => {
  return (
    <section
      id="inicio"
      data-testid="hero-section"
      className="relative min-h-[88vh] md:min-h-[92vh] w-full overflow-hidden"
    >
      <img
        src={HERO_IMG}
        alt="Lago e floresta em Igaratá"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8 pt-40 pb-24 md:pt-48 md:pb-32 text-white">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/40 bg-white/10 backdrop-blur-sm text-xs sm:text-sm tracking-wide mb-6">
          <MapPin className="h-3.5 w-3.5" />
          Igaratá — São Paulo
        </div>

        <h1
          data-testid="hero-title"
          className="text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight max-w-3xl leading-[1.05] text-balance"
        >
          Refúgios à beira do lago, entre a mata e o silêncio.
        </h1>
        <p className="mt-6 max-w-2xl text-base sm:text-lg leading-relaxed text-white/90">
          Três acomodações exclusivas — dois domos geodésicos e um container —
          com jacuzzi privativa, parrilla argentina e vista panorâmica para a
          represa do Jaguari.
        </p>

        <div className="mt-9 flex flex-col sm:flex-row gap-3">
          <a
            href="#chales"
            data-testid="hero-cta-cabanas"
            className="inline-flex items-center justify-center rounded-full bg-[#f7f5f0] text-[#1a3622] px-7 py-3.5 text-sm font-semibold hover:bg-white transition-colors"
          >
            Conhecer os chalés
          </a>
          <a
            href="#reserva"
            data-testid="hero-cta-reservar"
            className="inline-flex items-center justify-center rounded-full bg-[#b55a30] text-white px-7 py-3.5 text-sm font-semibold hover:bg-[#9d4d27] transition-colors"
          >
            Reservar agora
          </a>
        </div>
      </div>
    </section>
  );
};
